
angular.module('trainerWebApp.controllers')
  .controller('GetStartedCongratsCtrl', ['$scope', '$routeParams', '$location', 'trackingService', 'accountFeatures', 'mtypes', function ($scope, $routeParams, $location, trackingService, accountFeatures, mtypes) {
    var courseId = $location.search().courseId;
    var missingId = $location.search().missingId;
    $scope.useSample = $location.search().useSample;
    $scope.thumbnailUrl = mfConfig.thumbnailUrl;

    $scope.openGSPreview = function () {
      if (courseId > 0) {
        post("/ActionLogs.aspx/LogGetStartedAction", { action: "GetStartedCongratsPreview"});
        var w = 1000, h = 750;
        var left = (screen.width / 2) - (w / 2);
        var top = (screen.height / 2) - (h / 2) - 100;
        var targetWin = window.open($scope.viewAsTraineeUrl + "#/preview/" + courseId, null, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        trackGS('GettingStarted_Congrats_Preview');
      }
    };
    $scope.customizeCourse = function () {
      $location.url('/TMS/Course_Dashboard/' + courseId);

      var flexApp = MF.getFlexApp();
      if (flexApp && courseId) {
        flexApp.showFirstCourse(!!missingId, missingId || 0);
      }
    };

    function post(uri, data, cb) {
      $.ajax(uri, {
        type: 'POST',
        data: data,
        success: cb,
        dataType: "json"
      });
    }

    function trackGS(eventName) {
      trackingService.trackEvent(trackingService.pages.getStarted.name, eventName);
    }
  }]);
